export interface FilterOption {
  id: number
  name: string
  slug: string
  group_id: number
}

export const FILTERS: FilterOption[] = [
  { id: 1, group_id: 1, name: 'Barbacoa', slug: 'barbacoa' },
  { id: 2, group_id: 1, name: 'Jardín', slug: 'jardin' },
  { id: 4, group_id: 1, name: 'Piscina', slug: 'piscina' },
  { id: 5, group_id: 1, name: 'Terraza', slug: 'terraza' },
  {
    id: 6,
    group_id: 1,
    name: 'Zona de aparcamiento',
    slug: 'zona-de-aparcamiento',
  },
  { id: 7, group_id: 2, name: 'Acceso internet', slug: 'acceso-internet' },
  {
    id: 8,
    group_id: 2,
    name: 'Actividades para niños',
    slug: 'actividades-para-ninos',
  },
  { id: 9, group_id: 2, name: 'Admite mascotas', slug: 'admite-mascotas' },
  {
    id: 10,
    group_id: 2,
    name: 'Bicicleta disponible',
    slug: 'bicicleta-disponible',
  },
  { id: 11, group_id: 2, name: 'Cuna disponible', slug: 'cuna-disponible' },
  { id: 13, group_id: 2, name: 'Lavado de ropa', slug: 'lavado-de-ropa' },
  { id: 14, group_id: 2, name: 'Paseos con guía', slug: 'paseos-con-guia' },
  {
    id: 15,
    group_id: 2,
    name: 'Restaurante (público)',
    slug: 'restaurante-publico',
  },
  {
    id: 16,
    group_id: 2,
    name: 'Servicio de canguro',
    slug: 'servicio-de-canguro',
  },
  { id: 17, group_id: 2, name: 'Se sirven cenas', slug: 'se-sirven-cenas' },
  { id: 18, group_id: 2, name: 'Se sirven comidas', slug: 'se-sirven-comidas' },
  {
    id: 19,
    group_id: 2,
    name: 'Se sirven desayunos',
    slug: 'se-sirven-desayunos',
  },
  {
    id: 21,
    group_id: 3,
    name: 'Aire acondicionado',
    slug: 'aire-acondicionado',
  },
  { id: 22, group_id: 3, name: 'Baño compartido', slug: 'bano-compartido' },
  {
    id: 23,
    group_id: 3,
    name: 'Baño en habitación',
    slug: 'bano-en-habitacion',
  },
  { id: 24, group_id: 3, name: 'Biblioteca', slug: 'biblioteca' },
  { id: 25, group_id: 3, name: 'Calefacción', slug: 'calefaccion' },
  { id: 26, group_id: 3, name: 'Chimenea', slug: 'chimenea' },
  { id: 27, group_id: 3, name: 'Cocina', slug: 'cocina' },
  {
    id: 28,
    group_id: 3,
    name: 'Colección de juegos',
    slug: 'coleccion-de-juegos',
  },
  { id: 29, group_id: 3, name: 'Comedor', slug: 'comedor' },
  { id: 31, group_id: 3, name: 'Equipo de música', slug: 'equipo-de-musica' },
  { id: 32, group_id: 3, name: 'Jacuzzi', slug: 'jacuzzi' },
  { id: 33, group_id: 3, name: 'Lavadora', slug: 'lavadora' },
  { id: 34, group_id: 3, name: 'Lavavajillas', slug: 'lavavajillas' },
  { id: 35, group_id: 3, name: 'Microondas', slug: 'microondas' },
  { id: 36, group_id: 3, name: 'Sala para eventos', slug: 'sala-para-eventos' },
  { id: 37, group_id: 3, name: 'Sala de estar', slug: 'sala-de-estar' },
  { id: 38, group_id: 3, name: 'Sauna', slug: 'sauna' },
  { id: 40, group_id: 3, name: 'Televisión', slug: 'television' },
  {
    id: 41,
    group_id: 3,
    name: 'Televisión en habitación',
    slug: 'television-en-habitacion',
  },
  {
    id: 42,
    group_id: 4,
    name: 'Habitación adaptada',
    slug: 'habitacion-adaptada',
  },
  { id: 43, group_id: 5, name: 'Acceso asfaltado', slug: 'acceso-asfaltado' },
  {
    id: 44,
    group_id: 5,
    name: 'Afueras del casco urbano',
    slug: 'afueras-del-casco-urbano',
  },
  { id: 45, group_id: 5, name: 'Aislada', slug: 'aislada' },
  { id: 46, group_id: 5, name: 'Cerca de la playa', slug: 'cerca-de-la-playa' },
  {
    id: 47,
    group_id: 5,
    name: 'En el casco urbano',
    slug: 'en-el-casco-urbano',
  },
  { id: 48, group_id: 5, name: 'Montaña', slug: 'montana' },
  { id: 50, group_id: 6, name: 'Alemán', slug: 'aleman' },
  { id: 51, group_id: 6, name: 'Catalán', slug: 'catalan' },
  { id: 52, group_id: 6, name: 'Español', slug: 'espanol' },
  { id: 53, group_id: 6, name: 'Euskera', slug: 'euskera' },
  { id: 54, group_id: 6, name: 'Francés', slug: 'frances' },
  { id: 55, group_id: 6, name: 'Gallego', slug: 'gallego' },
  { id: 56, group_id: 6, name: 'Inglés', slug: 'ingles' },
  { id: 57, group_id: 6, name: 'Italiano', slug: 'italiano' },
  { id: 58, group_id: 6, name: 'Neerlandés', slug: 'neerlandes' },
  { id: 59, group_id: 6, name: 'Portugués', slug: 'portugues' },
  { id: 60, group_id: 7, name: 'Q de calidad', slug: 'q-de-calidad' },
  { id: 66, group_id: 1, name: 'Huerto ecológico', slug: 'huerto-ecologico' },
  { id: 67, group_id: 1, name: 'Granja', slug: 'granja' },
  { id: 68, group_id: 3, name: 'Billar', slug: 'billar' },
  { id: 69, group_id: 3, name: 'Ping pong', slug: 'ping-pong' },
  { id: 70, group_id: 3, name: 'Futbolín', slug: 'futbolin' },
  {
    id: 71,
    group_id: 3,
    name: 'Bañera de hidromasaje',
    slug: 'banera-de-hidromasaje',
  },
  { id: 72, group_id: 5, name: 'Cerca de un río', slug: 'cerca-de-un-rio' },
  { id: 73, group_id: 5, name: 'Cerca de un lago', slug: 'cerca-de-un-lago' },
  {
    id: 74,
    group_id: 5,
    name: 'Cerca de pistas de esquí',
    slug: 'cerca-de-pistas-de-esqui',
  },
  { id: 75, group_id: 3, name: 'Spa', slug: 'spa' },
  { id: 76, group_id: 1, name: 'Bar', slug: 'bar' },
  { id: 77, group_id: 1, name: 'Sala de juegos', slug: 'sala-de-juegos' },
  { id: 78, group_id: 1, name: 'Tenis', slug: 'tenis' },
  {
    id: 79,
    group_id: 3,
    name: 'Chimenea en la habitación',
    slug: 'chimenea-en-la-habitacion',
  },
  {
    id: 80,
    group_id: 3,
    name: 'Jacuzzi en la habitación',
    slug: 'jacuzzi-en-la-habitacion',
  },
  {
    id: 81,
    group_id: 3,
    name: 'Piscina climatizada',
    slug: 'piscina-climatizada',
  },
  {
    id: 82,
    group_id: 5,
    name: 'Cerca de un bosque',
    slug: 'cerca-de-un-bosque',
  },
  {
    id: 83,
    group_id: 8,
    name: 'Geprüfter Landsichten Ferienhof',
    slug: 'geprufter-landsichten-ferienhof',
  },
  { id: 84, group_id: 8, name: 'DLG Gütezeichen', slug: 'dlg-gutezeichen' },
  { id: 85, group_id: 7, name: 'Una estrella', slug: 'una-estrella' },
  { id: 86, group_id: 7, name: 'Dos estrellas', slug: 'dos-estrellas' },
  { id: 87, group_id: 7, name: 'Tres estrellas', slug: 'tres-estrellas' },
  { id: 88, group_id: 7, name: 'Cuatro estrellas', slug: 'cuatro-estrellas' },
  { id: 89, group_id: 7, name: 'Cinco estrellas', slug: 'cinco-estrellas' },
  {
    id: 90,
    group_id: 5,
    name: 'Cerca de campo de Golf',
    slug: 'cerca-de-campo-de-golf',
  },
  { id: 500, group_id: 1, name: 'Piscina', slug: 'piscina' },
  { id: 501, group_id: 1, name: 'Hidromasaje', slug: 'hidromasaje' },
  { id: 502, group_id: 2, name: 'Opciones comida', slug: 'opciones-comida' },
]

/**
 * Get filter by ID
 */
export function getFilterById(id: number): FilterOption | undefined {
  return FILTERS.find(filter => filter.id === id)
}

/**
 * Convert array of filter IDs to comma-separated string
 * This is the format expected by the `f` parameter
 */
export function filtersToString(filterIds: number[]): string {
  return filterIds.join(',')
}

/**
 * Convert comma-separated string to array of filter IDs
 */
export function stringToFilters(filterString: string): number[] {
  if (!filterString) return []
  return filterString
    .split(',')
    .map(id => parseInt(id, 10))
    .filter(id => !isNaN(id))
}
